import React from 'react';
import cn from 'classnames';

type ModalButtonsProps = {
  centered?: boolean
}

export default function ModalButtons({centered, children}: React.PropsWithChildren<ModalButtonsProps>) {
  return (
    <div className={cn('mt-5', {'flex justify-between': centered})}>
      {children}
    </div>
  );
}
